export const VACANCIES_PAGES = {
  createVacancy: 'create-vacancy',
  vacancyDetails: 'vacancy',
  applicantRequestForm: 'applicant-request-form',
};

export const VACANCIES_MODALS = {
  tableFilter: 'tableFilter',
  deleteVacancy: 'deleteVacancy',
  publishVacancy: 'publishVacancy',
  closeVacancy: 'closeVacancy',
};
